import GalleryButton  from './GalleryButton';

export default GalleryButton ;